/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useAuth } from "@/Providers/Auth";
import { useStaticData } from "@/Providers/Data";
import { useGeneralSettings } from "@/Providers/General";
import { useInfluencer } from "@/Providers/Influencer";
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  profileDataProps,
  contentDataProps,
  audienceDataProps,
  chargesDataProps,
  collabDataProps,
  monetizationDataProps,
} from "./BuildProfileProps";
import { useToast } from "@/shadcnComponents/ui/use-toast";
import { dataUriToFile, generateRandomName } from "./BuildProfileHelpers";
import mixpanel from "mixpanel-browser";
import { getOrdinalSuffix, isValidUrl } from "@/Helpers/helper";

export const useBuildProfileHooks = () => {
  const authState = useAuth();
  const influencerState = useInfluencer();
  const generalState = useGeneralSettings();
  const dataState = useStaticData();
  const navigate = useNavigate();
  const { toast } = useToast();
  const [loading, setLoading] = useState(false);

  // for checking the type of service we need to create --------------------------------------
  const { search } = useLocation();
  const query = new URLSearchParams(search);

  const [currentPage, setCurrentPage] = useState("profile");
  const [chipsData, setChipsData] = useState({});
  const [errorArray, setErrorArray] = useState([]);

  // images states --------
  const [formTwoImages, setFormTwoImages] = useState([]);
  const [profileFormImages, setProfileFormImages] = useState<[]>([]);

  const [TempInfluData, setTempInfluData] = useState<{
    avgLikes: number;
    avgComments: number;
    avgEngagement: number;
    avgEngagementPercent: any;
    avgReposts: number;
    followers: number;
    topThreeEngagedPosts: [];
    name: string;
    gender: string;
    tagline: string;
    location: string;
    profile_image: string;
    experience: string;
    badge: string;
    featured: [];
    profile_url: string;
    firstThirtyLikes: number[];
    firstThirtyComments: number[];
    topLinks: [];
  }>();
  const [influContentCategory, SetInfluContentCategory] = useState<string[]>();
  const [profileData, setProfileData] = useState<profileDataProps>({
    name: "",
    tagline: "",
    linkedinLink: "",
    gender: "",
    twitterLink: "",
    instaLink: "",
    linkTreeLink: "",
    whatsappLink: "",
    YouTubeLink: "",
    fbLink: "",
    telegramLink: "",
    coverPhoto: "",
    profile: "",
    websiteLink: "",
    followers: {
      linkedin: null,
      twitter: null,
      fb: null,
      telegram: null,
      insta: null,
      website: null,
      linktree: null,
      whatsapp: null,
      youTube: null,
    },
    location: {
      country: "India",
      state: "",
      city: "",
    },
    dob: "",
  });
  const [contentData, setContentData] = useState<contentDataProps>({
    categories: [],
    formats: [],
  });
  const [audienceData, setAudienceData] = useState<audienceDataProps>({
    types: [],
    platforms: [
      {
        platform: "",
        audience: null,
        link: "",
      },
    ],
  });
  const [chargesData, setChargesData] = useState<chargesDataProps>({
    PostMaxPrice: null,
    PostMinPrice: null,
    MonthlyNumberOfPost: null,
    MonthlyMaxPrice: null,
    MonthlyMinPrice: null,
    YearlyNumberOfPost: null,
    YearlyMaxPrice: null,
    YearlyMinPrice: null,
    AcceptFreeBies: true,
    isNegotiable: false,
  });
  const [collabData, setCollabData] = useState<[collabDataProps]>([
    {
      companyName: "",
      companyUrl: "",
      companyProfile: "",
      postLink: "",
      goals: [],
    },
  ]);
  const [monetizationData, setMonetizationData] = useState<
    monetizationDataProps[]
  >([
    {
      platformName: "",
      profileLink: "",
      paidAudience: null,
      methods: [],
    },
  ]);
  const [topLinksData, setTopLinksData] = useState<any>({});

  const [masterMonetizationPlatform, setMasterMonetizationPlatform] = useState(
    []
  );
  //useEffects
  useEffect(() => {
    if (query.get("page")) {
      setCurrentPage(query.get("page"));
    }
  }, [query]);
  useEffect(() => {
    generalState.setLoading(true);
    const getTempInfluencerData = async () => {
      await influencerState
        .getTempInfluencerLinkedinProfileFromSlug(authState?.loggedUser?.slug)
        .then((resData) => {
          if (resData.success) {
            setTempInfluData(resData?.LinkedinAnalysis);
            SetInfluContentCategory(resData?.ContentCategory);
            generalState.setLoading(false);
          } else {
            generalState.setLoading(false);
            setLoading(false);
            alert(resData?.error || "Some Error Occurred!");
            navigate("/");
          }
        });
    };

    getTempInfluencerData();
  }, [currentPage]);
  useEffect(() => {
    setErrorArray([]);
    generalState.setLoading(true);
    setLoading(true);
    influencerState?.getPersonalInfo().then((e) => {
      if (e?.success) {
        setProfileData({
          ...profileData,
          ...e?.data,
        });
        setProfileData((prev) => {
          return {
            ...prev,
            tagline: prev?.tagline || TempInfluData?.tagline,
            gender: prev?.gender || TempInfluData?.gender,
          };
        });

        if (e?.data2?.data?.length) {
          setCollabData(
            e?.data2?.data ?? [
              {
                companyName: "",
                companyUrl: "",
                companyProfile: "",
                postLink: "",
                goals: [],
              },
            ]
          );
        } else {
          setCollabData([
            {
              companyName: "",
              companyUrl: "",
              companyProfile: "",
              postLink: "",
              goals: [],
            },
          ]);
        }

        if (e?.data3?.data.length) {
          setMonetizationData(
            e?.data3?.data ?? [
              {
                platformName: "",
                profileLink: "",
                paidAudience: null,
                methods: [],
              },
            ]
          );
        } else {
          setMonetizationData([
            {
              platformName: "",
              profileLink: "",
              paidAudience: null,
              methods: [],
            },
          ]);
        }

        setContentData(
          e.data4 ?? {
            categories: influContentCategory || [],
            formats: [],
          }
        );

        if (e?.data5?.platforms?.length || e?.data5?.types?.length) {
          setAudienceData(
            e.data5 ?? {
              ...audienceData,
              platforms: [
                {
                  platform: "",
                  audience: null,
                  link: "",
                },
              ],
            }
          );
        } else {
          setAudienceData({
            ...audienceData,
            platforms: [
              {
                platform: "",
                audience: null,
                link: "",
              },
            ],
          });
        }

        if (e?.data5?.topLinks?.length) {
          setTopLinksData({ topLinks: e?.data5?.topLinks });
        } else {
          setTopLinksData({
            topLinks: [
              {
                link: "",
                linkText: "",
                icon: "",
              },
            ],
          });
        }

        setChargesData(
          e.data6 ?? {
            PostMaxPrice: null,
            PostMinPrice: null,
            MonthlyNumberOfPost: null,
            MonthlyMaxPrice: null,
            MonthlyMinPrice: null,
            YearlyNumberOfPost: null,
            YearlyMaxPrice: null,
            YearlyMinPrice: null,
            AcceptFreeBies: true,
            isNegotiable: false,
          }
        );
      }
      generalState.setLoading(false);
      setLoading(false);
    });
  }, [currentPage]);
  useEffect(() => {
    dataState?.getDataFromType("Influencer Chips").then((e) => {
      setChipsData(e[0]);
    });
    dataState?.getNewDataFromType("Platform Name").then((e) => {
      setMasterMonetizationPlatform(e);
    });
  }, []);
  useEffect(() => {
    setErrorArray([]);
    const cfd1 = CountTheChips(profileData, "personal");
    const cfd2 = CountTheChips(collabData, "collab");
    const cfd3 = CountTheChips(monetizationData, "monetisation");
    const cfd4 = CountTheChips(contentData, "content");
    const cfd5 = CountTheChips(audienceData, "audience");
    const cfd6 = CountTheChips(chargesData, "charges");
    const cdf7 =
      authState?.loggedUser?.referralCount * parseInt(chipsData?.["referral"]);

    generalState?.setSidebarChipsCount({
      profile: cfd1,
      collab: cfd2,
      monetization: cfd3,
      content: cfd4,
      audience: cfd5,
      charges: cfd6,
      referral: cdf7,
    });
  }, [
    profileData,
    contentData,
    audienceData,
    monetizationData,
    collabData,
    chargesData,
  ]);

  //controllers
  const handleSubmit = async ({ noNavigate }) => {
    generalState?.setLoading(true);
    if (currentPage === "profile") {
      await handleSubmitProfileForm();
      generalState?.setLoading(false);
    } else if (currentPage === "content") {
      await handleSubmitContentForm();
      generalState?.setLoading(false);
    } else if (currentPage === "audience") {
      await handleSubmitAudienceForm();
      generalState?.setLoading(false);
    } else if (currentPage === "collab") {
      await handleSubmitCollabForm({ noNavigate });
      generalState?.setLoading(false);
    } else if (currentPage === "monetization") {
      await handleSubmitMonetizationForm({ noNavigate });
      generalState?.setLoading(false);
    } else if (currentPage === "pricing") {
      await handleSubmitChargesForm();
      generalState?.setLoading(false);
    } else if (currentPage === "toplinks") {
      await handleSubmitTopLinksForm();
      generalState?.setLoading(false);
    }
  };
  // submit functions ------------------
  const handleSubmitProfileForm = async () => {
    try {
      if (profileData?.name?.length < 1) {
        setErrorArray((prev) => {
          const newArr = [...prev, "name"];
          return newArr;
        });
        toast({
          variant: "destructive",
          title: "There was a problem with your request.",
          description: "Please Enter proper Name",
        });
        return;
      } else if (profileData?.tagline?.length < 1) {
        setErrorArray((prev) => {
          const newArr = [...prev, "tagline"];
          return newArr;
        });
        toast({
          variant: "destructive",
          title: "There was a problem with your request.",
          description: "Please Enter Your Tagline",
        });
        return;
      } else if (!profileData?.gender || profileData?.gender === "") {
        setErrorArray((prev) => {
          const newArr = [...prev, "gender"];
          return newArr;
        });
        toast({
          variant: "destructive",
          title: "There was a problem with your request.",
          description: "Please Select Gender",
        });
        return;
      } else if (!profileData?.dob) {
        setErrorArray((prev) => {
          const newArr = [...prev, "dob"];
          return newArr;
        });
        toast({
          variant: "destructive",
          title: "There was a problem with your request.",
          description: "Please Select Date of Birth",
        });
        return;
      } else {
        const instaLinkRegex =
          /(?:https?:\/\/)?(?:www\.)?instagram\.com\/(?!p\/|explore\/|stories\/|directory\/|accounts\/|tv\/|reel\/)([A-Za-z0-9_](?:(?:[A-Za-z0-9_]|(?:\.(?!\.))){0,28}(?:[A-Za-z0-9_]))?)(?:\/)?/;
        const linkedinLinkRegex =
          /^(https?:\/\/)?(www\.)?linkedin\.com\/in\/[a-zA-Z0-9_-]+\/?$/;
        const twitterLinkRegex =
          /^(https?:\/\/)?(www\.)?twitter\.com\/[a-zA-Z0-9_]+\/?$/;
        const telegramLinkRegex =
          /^(https?:\/\/)?(|www)[.]?((t|telegram)\.me)\/[a-zA-Z0-9_]{5, 32}$/;
        const fbLinkRegex =
          /^(https?:\/\/)?(www\.)?facebook\.com\/[a-zA-Z0-9_-]+\/?$/;
        const whatsappLinkRegex =
          /(?:https?:\/\/)?(?:www\.)?(?:chat\.whatsapp\.com|invite\.whatsapp\.com)\/?(?:[a-zA-Z0-9]+)?(?:\?|&)?(invite=)?([a-zA-Z0-9]+)/g;
        const youTubeLinkRegex =
          /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:channel\/|user\/|c\/)?|youtu\.be\/|youtube\.com\/@)([a-zA-Z0-9_-]{24}|[a-zA-Z0-9_-]+)/;
        const linkTreeLinkRegex =
          /(?:https?:\/\/)?(?:www\.)?linktr\.ee\/([a-zA-Z0-9_]+)/;

        if (
          profileData?.instaLink &&
          !instaLinkRegex.test(profileData?.instaLink)
        ) {
          return toast({
            variant: "destructive",
            title: "There was a problem with your request.",
            description: "Please Enter proper Instagram Link",
          });
        } else if (profileData?.instaLink && !profileData?.followers?.insta) {
          return toast({
            variant: "destructive",
            title: "There was a problem with your request.",
            description: "Please Enter Instagram followers",
          });
        } else if (profileData?.followers?.insta && !profileData?.instaLink) {
          return toast({
            variant: "destructive",
            title: "There was a problem with your request.",
            description: "Please Enter Instagram Link",
          });
        }
        if (
          profileData?.linkedinLink &&
          !linkedinLinkRegex.test(profileData?.linkedinLink)
        ) {
          return toast({
            variant: "destructive",
            title: "There was a problem with your request.",
            description: "Please Enter proper Linkedin Link",
          });
        } else if (
          profileData?.linkedinLink &&
          !profileData?.followers?.linkedin
        ) {
          return toast({
            variant: "destructive",
            title: "There was a problem with your request.",
            description: "Please Enter Linkedin followers",
          });
        } else if (
          profileData?.followers?.linkedin &&
          !profileData?.linkedinLink
        ) {
          return toast({
            variant: "destructive",
            title: "There was a problem with your request.",
            description: "Please Enter linkedin Link",
          });
        }
        if (
          profileData?.telegramLink &&
          !telegramLinkRegex.test(profileData?.telegramLink)
        ) {
          return toast({
            variant: "destructive",
            title: "There was a problem with your request.",
            description: "Please Enter proper Telegram Link",
          });
        } else if (
          profileData?.telegramLink &&
          !profileData?.followers?.telegram
        ) {
          return toast({
            variant: "destructive",
            title: "There was a problem with your request.",
            description: "Please Enter Telegram followers",
          });
        } else if (
          profileData?.followers?.telegram &&
          !profileData?.telegramLink
        ) {
          return toast({
            variant: "destructive",
            title: "There was a problem with your request.",
            description: "Please Enter Telegram Link",
          });
        }
        if (
          profileData?.twitterLink &&
          !twitterLinkRegex.test(profileData?.twitterLink)
        ) {
          return toast({
            variant: "destructive",
            title: "There was a problem with your request.",
            description: "Please Enter proper Twitter Link",
          });
        } else if (
          profileData?.twitterLink &&
          !profileData?.followers?.twitter
        ) {
          return toast({
            variant: "destructive",
            title: "There was a problem with your request.",
            description: "Please Enter Twitter followers",
          });
        } else if (
          profileData?.followers?.twitter &&
          !profileData?.twitterLink
        ) {
          return toast({
            variant: "destructive",
            title: "There was a problem with your request.",
            description: "Please Enter Twitter Link",
          });
        }

        if (profileData?.fbLink && !fbLinkRegex.test(profileData?.fbLink)) {
          return toast({
            variant: "destructive",
            title: "There was a problem with your request.",
            description: "Please Enter proper Facebook Link",
          });
        } else if (profileData?.fbLink && !profileData?.followers?.fb) {
          return toast({
            variant: "destructive",
            title: "There was a problem with your request.",
            description: "Please Enter Facebook followers",
          });
        } else if (profileData?.followers?.fb && !profileData?.fbLink) {
          return toast({
            variant: "destructive",
            title: "There was a problem with your request.",
            description: "Please Enter Facebook Link",
          });
        }

        if (profileData?.websiteLink && !profileData?.followers?.website) {
          return toast({
            variant: "destructive",
            title: "There was a problem with your request.",
            description: "Please Enter Website followers",
          });
        } else if (
          profileData?.followers?.website &&
          !profileData?.websiteLink
        ) {
          return toast({
            variant: "destructive",
            title: "There was a problem with your request.",
            description: "Please Enter Website Link",
          });
        }

        if (
          profileData?.whatsappLink &&
          !whatsappLinkRegex.test(profileData?.whatsappLink)
        ) {
          return toast({
            variant: "destructive",
            title: "There was a problem with your request.",
            description: "Please Enter proper WhatsApp Link",
          });
        } else if (
          profileData?.whatsappLink &&
          !profileData?.followers?.whatsapp
        ) {
          return toast({
            variant: "destructive",
            title: "There was a problem with your request.",
            description: "Please Enter WhatsApp followers",
          });
        } else if (
          profileData?.followers?.whatsapp &&
          !profileData?.whatsappLink
        ) {
          return toast({
            variant: "destructive",
            title: "There was a problem with your request.",
            description: "Please Enter WhatsApp Link",
          });
        }

        if (
          profileData?.YouTubeLink &&
          !youTubeLinkRegex.test(profileData?.YouTubeLink)
        ) {
          return toast({
            variant: "destructive",
            title: "There was a problem with your request.",
            description: "Please Enter proper YouTube Link",
          });
        } else if (
          profileData?.YouTubeLink &&
          !profileData?.followers?.youTube
        ) {
          return toast({
            variant: "destructive",
            title: "There was a problem with your request.",
            description: "Please Enter YouTube followers",
          });
        } else if (
          profileData?.followers?.youTube &&
          !profileData?.YouTubeLink
        ) {
          return toast({
            variant: "destructive",
            title: "There was a problem with your request.",
            description: "Please Enter YouTube Link",
          });
        }

        if (
          profileData?.linkTreeLink &&
          !linkTreeLinkRegex.test(profileData?.linkTreeLink)
        ) {
          return toast({
            variant: "destructive",
            title: "There was a problem with your request.",
            description: "Please Enter proper linktree Link",
          });
        } else if (
          profileData?.linkTreeLink &&
          !profileData?.followers?.linktree
        ) {
          return toast({
            variant: "destructive",
            title: "There was a problem with your request.",
            description: "Please Enter linktree followers",
          });
        } else if (
          profileData?.followers?.linktree &&
          !profileData?.linkTreeLink
        ) {
          return toast({
            variant: "destructive",
            title: "There was a problem with your request.",
            description: "Please Enter linktree Link",
          });
        }

        let coverPhoto = profileData.coverPhoto;
        let profile = profileData.profile;
        if (profileFormImages.length > 0) {
          for (let index = 0; index < profileFormImages.length; index++) {
            const element = profileFormImages[index];
            if (element) {
              const data1 = new FormData();
              const randomName = generateRandomName();
              const file = dataUriToFile(element, randomName + ".png");
              data1.append("file", file);
              const result = await influencerState?.uploadInfluencerImages(
                data1
              );
              if (result?.success) {
                if (index === 0) {
                  coverPhoto = result?.result?.Location;
                } else {
                  profile = result?.result?.Location;
                }
              }
            }
          }
        }
        const response = await influencerState?.updatePersonalInfo({
          ...profileData,
          coverPhoto,
          profile,
        });
        if (response?.success) {
          // setCurrentPage("content");
          navigate(
            `/influencer/build_profile?page=${
              authState?.loggedUser?.extensionUsage?.lastSyncTime
                ? "collab"
                : "content"
            }`
          );
        }
      }
    } catch (error) {
      toast({
        variant: "destructive",
        title: "There was a problem with your request.",
        description: "Please Retry",
      });
    }
  };
  const handleSubmitContentForm = async () => {
    try {
      const response = await influencerState?.updateContentInfo(contentData);
      if (response?.success) {
        // setCurrentPage("audience");

        navigate("/influencer/build_profile?page=audience");
      }
    } catch (error) {
      toast({
        variant: "destructive",
        title: "There was a problem with your request.",
        description: "Please Retry",
      });
    }
  };
  const handleSubmitAudienceForm = async () => {
    try {
      const check = checkValidationOfData(
        audienceData?.platforms,
        {
          platform: "",
          audience: null,
          link: "",
        },
        (e, index) => {
          if (!e?.platform) {
            toast({
              variant: "destructive",
              title: "There was a problem with your request.",
              description: "Please Select Platform Name",
            });
            setErrorArray((prev) => {
              const newArr = [...prev, "audience" + index + "platform"];
              return newArr;
            });
            return false;
          } else if (e?.audience === null) {
            toast({
              variant: "destructive",
              title: "There was a problem with your request.",
              description: "Please Enter Audience Size",
            });
            setErrorArray((prev) => {
              const newArr = [...prev, "audience" + index + "audience"];
              return newArr;
            });
            return false;
          } else if (e?.link?.length < 1) {
            toast({
              variant: "destructive",
              title: "There was a problem with your request.",
              description: "Please Enter Link",
            });
            setErrorArray((prev) => {
              const newArr = [...prev, "audience" + index + "link"];
              return newArr;
            });
            return false;
          }
          return true;
        }
      );
      if (!check) {
        // toast({
        //   variant: "destructive",
        //   title: "There was a problem with your request.",
        //   description: "Please fill the mandatory details to continue",
        // });
        return;
      } else {
        const response = await influencerState?.updateAudienceInfo(
          audienceData
        );
        if (response?.success) {
          // setCurrentPage("verification");
          navigate("/influencer/build_profile?page=collab");
        }
      }
    } catch (error) {
      toast({
        variant: "destructive",
        title: "There was a problem with your request.",
        description: "Please Retry",
      });
    }
  };
  const handleSubmitCollabForm = async ({ noNavigate }) => {
    try {
      const check = checkValidationOfData(
        collabData,
        {
          companyName: "",
          companyUrl: "",
          companyProfile: "",
          postLink: "",
          goals: [],
        },
        (e, index) => {
          if (e?.companyName?.length < 1) {
            setErrorArray((prev) => {
              const newArr = [...prev, "collab" + index + "companyName"];
              return newArr;
            });
            toast({
              variant: "destructive",
              title: "There was a problem with your request.",
              description: `Please enter company name at ${getOrdinalSuffix(
                index + 1
              )} card to continue`,
            });
            return false;
          } else if (e?.companyUrl?.length < 1) {
            setErrorArray((prev) => {
              const newArr = [...prev, "collab" + index + "companyUrl"];
              return newArr;
            });
            toast({
              variant: "destructive",
              title: "There was a problem with your request.",
              description: `Please enter company website at ${getOrdinalSuffix(
                index + 1
              )} card to continue`,
            });
            return false;
          } else if (e?.postLink?.length < 1) {
            setErrorArray((prev) => {
              const newArr = [...prev, "collab" + index + "postLink"];
              return newArr;
            });
            toast({
              variant: "destructive",
              title: "There was a problem with your request.",
              description: `Please enter post link at ${getOrdinalSuffix(
                index + 1
              )} card to continue`,
            });
            return false;
          } else if (!isValidUrl(e?.postLink)) {
            setErrorArray((prev) => {
              const newArr = [...prev, "collab" + index + "postLink"];
              return newArr;
            });
            toast({
              variant: "destructive",
              title: "Link Invalid",
              description: `Please enter a valid link at ${getOrdinalSuffix(
                index + 1
              )} card to continue`,
            });
            return false;
          }
          return true;
        }
      );
      if (!check) {
        return;
      } else {
        const data = await saveLogosCompany();
        const response = await influencerState?.updateCollabInfo(data);
        if (response?.success) {
          // setCurrentPage(3);
          if (noNavigate) {
            return toast({
              title: "Details Saved Successfully",
            });
          } else {
            navigate("/influencer/build_profile?page=monetization");
          }
        }
      }
    } catch (error) {
      toast({
        variant: "destructive",
        title: "Some error occurred while saving the data.",
        description: "Try Again",
      });
    }
  };
  const handleSubmitMonetizationForm = async ({ noNavigate }) => {
    try {
      const findPlatformName = (e) => {
        return masterMonetizationPlatform?.find(
          (platform) => platform?._id === e?.platformName
        )?.monetizationPlatformName;
      };
      const check = checkValidationOfData(
        monetizationData,
        {
          platformName: "",
          profileLink: "",
          paidAudience: null,
          methods: [],
        },
        (e, index) => {
          if (findPlatformName(e)?.length < 1) {
            setErrorArray((prev) => {
              const newArr = [...prev, "monetization" + index + "platformName"];
              return newArr;
            });
            toast({
              variant: "destructive",
              title: "There was a problem with your request.",
              description: `Please enter platform name at ${getOrdinalSuffix(
                index + 1
              )} card to continue`,
            });
            return false;
          } else if (
            findPlatformName(e) !== "None" &&
            e?.profileLink?.length < 1
          ) {
            setErrorArray((prev) => {
              const newArr = [...prev, "monetization" + index + "profileLink"];
              return newArr;
            });
            toast({
              variant: "destructive",
              title: "There was a problem with your request.",
              description: `Please enter profile link at ${getOrdinalSuffix(
                index + 1
              )} card to continue`,
            });
            return false;
          } else if (
            findPlatformName(e) !== "None" &&
            !isValidUrl(e?.profileLink)
          ) {
            setErrorArray((prev) => {
              const newArr = [...prev, "monetization" + index + "profileLink"];
              return newArr;
            });
            toast({
              variant: "destructive",
              title: "Link Invalid",
              description: `Please enter a valid profile link at ${getOrdinalSuffix(
                index + 1
              )} card to continue`,
            });
            return false;
          } else if (
            findPlatformName(e) !== "None" &&
            e?.paidAudience === null
          ) {
            setErrorArray((prev) => {
              const newArr = [...prev, "monetization" + index + "paidAudience"];
              return newArr;
            });
            toast({
              variant: "destructive",
              title: "There was a problem with your request.",
              description: `Please enter paid audience at ${getOrdinalSuffix(
                index + 1
              )} card to continue`,
            });
            return false;
          }
          return true;
        }
      );
      if (!check) {
        return;
      } else {
        const response = await influencerState?.updateMonetizationInfo(
          monetizationData
        );
        if (response?.success) {
          if (noNavigate) {
            return toast({
              title: "Details Saved Successfully",
            });
          } else {
            // setCurrentPage(4);
            navigate("/influencer/build_profile?page=pricing");
          }
        }
      }
    } catch (error) {
      toast({
        variant: "destructive",
        title: "There was a problem with your request.",
        description: "Some error occurred while saving the data",
      });
    }
  };
  const handleSubmitChargesForm = async () => {
    try {
      if (chargesData?.PostMaxPrice || chargesData?.PostMinPrice) {
        if (!chargesData?.PostMaxPrice) {
          return toast({
            variant: "destructive",
            title: "There was a problem with your request.",
            description: "Please fill Per-post max price",
          });
        } else if (!chargesData?.PostMinPrice) {
          return toast({
            variant: "destructive",
            title: "There was a problem with your request.",
            description: "Please fill Per-post min price",
          });
        } else if (
          parseInt(chargesData?.PostMinPrice?.toString()) >
          parseInt(chargesData?.PostMaxPrice?.toString())
        ) {
          return toast({
            variant: "destructive",
            title: "There was a problem with your request.",
            description: "Invalid Price",
          });
        }
      }
      if (
        chargesData?.MonthlyNumberOfPost ||
        chargesData?.MonthlyMinPrice ||
        chargesData?.MonthlyMinPrice
      ) {
        if (!chargesData?.MonthlyNumberOfPost) {
          return toast({
            variant: "destructive",
            title: "There was a problem with your request.",
            description: "Please fill Monthly Number Of Poste",
          });
        } else if (!chargesData?.MonthlyMinPrice) {
          return toast({
            variant: "destructive",
            title: "There was a problem with your request.",
            description: "Please fill Monthly Min price",
          });
        } else if (!chargesData?.MonthlyMaxPrice) {
          return toast({
            variant: "destructive",
            title: "There was a problem with your request.",
            description: "Please fill Monthly Max price",
          });
        } else if (
          parseInt(chargesData?.MonthlyMinPrice?.toString()) >
          parseInt(chargesData?.MonthlyMaxPrice?.toString())
        ) {
          return toast({
            variant: "destructive",
            title: "There was a problem with your request.",
            description: "Invalid Price",
          });
        }
      }
      if (
        chargesData?.YearlyNumberOfPost ||
        chargesData?.YearlyMinPrice ||
        chargesData?.YearlyMinPrice
      ) {
        if (!chargesData?.YearlyNumberOfPost) {
          return toast({
            variant: "destructive",
            title: "There was a problem with your request.",
            description: "Please fill Yearly Number Of Post",
          });
        } else if (!chargesData?.YearlyMinPrice) {
          return toast({
            variant: "destructive",
            title: "There was a problem with your request.",
            description: "Please fill Yearly Min price",
          });
        } else if (!chargesData?.YearlyMaxPrice) {
          return toast({
            variant: "destructive",
            title: "There was a problem with your request.",
            description: "Please fill Yearly Max price",
          });
        } else if (
          parseInt(chargesData?.YearlyMinPrice?.toString()) >
          parseInt(chargesData?.YearlyMaxPrice?.toString())
        ) {
          return toast({
            variant: "destructive",
            title: "There was a problem with your request.",
            description: "Invalid Price",
          });
        }
      }
      const response = await influencerState?.updateChargesInfo(chargesData);
      if (response?.success) {
        // setCurrentPage(5);
        // alert("form Saved");
        // toast.("Some error occurred while saving the data",{
        //   autoClose:2000
        // });
        navigate(`/influencer/share_profile`);
      }
    } catch (error) {
      return toast({
        variant: "destructive",
        title: "There was a problem with your request.",
        description: "Some error occurred while saving the data",
      });
    }
  };
  const handleSubmitTopLinksForm = async () => {
    mixpanel.track("Top Links Form Submitted: clicked save button");
    try {
      // Check if there are no links provided
      if (!topLinksData?.topLinks) {
        return toast({
          variant: "destructive",
          title: "There was a problem with your request.",
          description: "Please add at least one link.",
        });
      }

      if (
        topLinksData.topLinks?.[0]?.link.length === 0 ||
        topLinksData.topLinks?.[0]?.linkText.length === 0
      ) {
        return toast({
          variant: "destructive",
          title: "There was a problem with your request.",
          description: "Please fill out both link and link text.",
        });
      }

      // Check if all sets of link and linkText are filled
      const incompleteLinks = topLinksData.topLinks.filter(
        (link) => !link?.link || !link?.linkText
      );

      if (incompleteLinks.length > 0) {
        return toast({
          variant: "destructive",
          title: "There was a problem with your request.",
          description:
            "Please fill all link and link text fields or delete incomplete sets.",
        });
      }

      // Filtering the empty links
      const updatedTopLinksData = topLinksData.topLinks.filter(
        (link) => link.linkText.trim().length > 0 && link.link.trim().length > 0
      );
      const response = await influencerState?.updateTopLinksInfo(
        updatedTopLinksData
      );
      if (response?.success) {
        toast({
          title: "Details Saved Successfully",
        });
      }
    } catch (error) {
      toast({
        variant: "destructive",
        title: "There was a problem with your request.",
        description: "Some error occurred while saving the data",
      });
    }
  };
  const saveLogosCompany = async () => {
    const data = collabData;
    if (formTwoImages.length > 0) {
      for (let index = 0; index < formTwoImages.length; index++) {
        const element = formTwoImages[index];
        if (element) {
          const data1 = new FormData();
          const randomName = generateRandomName();
          const file = dataUriToFile(element, randomName + ".png");
          data1.append("file", file);
          const result = await influencerState?.uploadCompanyImages(data1);
          if (result?.success) {
            data[index].companyProfile = result?.result?.Location;
          }
        }
      }
    }
    return data;
  };
  const checkValidationOfData = (data, originalObj, callback) => {
    const newData = []; // Array to store modified data without original objects

    for (let index = 0; index < data.length; index++) {
      const element = data[index];

      if (element?._id) {
        delete element._id;
      }

      if (JSON.stringify(element) !== JSON.stringify(originalObj)) {
        const res = callback(element, index);
        if (!res) {
          return false;
        }
        newData.push(element);
        // Do nothing or perform additional actions if needed
      }
    }

    data.splice(0, data.length, ...newData);

    return true;
  };
  //  real time chips changes ------------------
  const GoThroughArray = (arr: any[], stringName: string) => {
    let chips: number = 0;

    if (arr.length > 0) {
      if (typeof arr[0] === "object") {
        // means the elements e=inside the array are objects ------------

        for (let index = 0; index < arr.length; index++) {
          const element = arr[index];
          const credits = GoThroughObjects(element, stringName);
          chips += credits;
        }
      } else {
        if (arr.filter((e) => e?.length > 0)?.length > 0) {
          if (chipsData[stringName]) {
            chips += chipsData[stringName];
          }
        }
      }
    }
    return chips;
  };

  const GoThroughObjects = (obj: object, stringName: string) => {
    let chips: number = 0;

    const keysArr = Object.keys(obj || {});
    const ValuesArr = Object.values(obj || {});

    for (let index = 0; index < ValuesArr.length; index++) {
      const element = ValuesArr[index];

      // is an array ---------------
      if (Array.isArray(element)) {
        const credits = GoThroughArray(
          element,
          stringName + "." + keysArr[index]
        );
        chips += credits;
      }

      // is an object ----------------
      else if (typeof element === "object") {
        const credits = GoThroughObjects(
          element,
          stringName + "." + keysArr[index]
        );
        chips += credits;
      }

      // is a string ------------------
      else {
        // find the value and add in the chips
        if (element !== null && element !== "") {
          if (chipsData[stringName + "." + keysArr[index]]) {
            chips += chipsData[stringName + "." + keysArr[index]];
          }

          //  followers edge cases
          else if (
            (stringName + "." + keysArr[index]).includes("personal.followers")
          ) {
            chips += chipsData["social.followers"];
          }

          //  social links edge cases
          else if (
            [
              "personal.linkedinLink",
              "personal.twitterLink",
              "personal.instaLink",
              "personal.fbLink",
              "personal.telegramLink",
              "personal.whatsappLink",
              "personal.YouTubeLink",
              "personal.linkTreeLink",
            ].includes(stringName + "." + keysArr[index])
          ) {
            chips += chipsData["social.link"];
          }
        }
      }
    }

    return chips;
  };

  function CountTheChips(data: object | [], stringName: string) {
    let credits: number = 0;

    // check is the data is objet or array
    if (Array.isArray(data)) {
      credits = GoThroughArray(data, stringName);
    }

    // is an object -------------
    else {
      credits = GoThroughObjects(data, stringName);
    }

    return credits;
  }

  return {
    currentPage,
    setCurrentPage,
    profileData,
    setProfileData,
    profileFormImages,
    setProfileFormImages,
    contentData,
    setContentData,
    audienceData,
    setAudienceData,
    collabData,
    setCollabData,
    formTwoImages,
    setFormTwoImages,
    monetizationData,
    setMonetizationData,
    chargesData,
    setChargesData,
    topLinksData,
    setTopLinksData,
    handleSubmit,
    errorArray,
    loading,
  };
};
